// JS for LPv2 Main Product Price block
export function initPriceBlock() {
  
  document.addEventListener('lpv2-state-changed', (e) => {
	
    const state = e.detail;
    // Update price, compare-at, and savings in the price block
    const priceEl = document.querySelector('.lpv2-main-product-price-block .lpv2-main-product-price');
    const compareEl = document.querySelector('.lpv2-main-product-price-block .lpv2-main-product-compare-at');
    const saveEl = document.querySelector('.lpv2-main-product-price-block .lpv2-main-product-savings-amount');
    const saveContainer = saveEl ? saveEl.closest('.lpv2-main-product-savings') : null;

    if (priceEl) priceEl.textContent = formatMoney(state.discountedPrice, state.currency, state.locale);
    if (compareEl) {
      // Use the variant's own compare_at_price (or price as fallback) for display
      const variant = state.selectedVariant;
      const baseCompareAt = variant ? (variant.compare_at_price || variant.price || 0) : 0;
      if (baseCompareAt > state.discountedPrice) {
        compareEl.textContent = formatMoney(baseCompareAt, state.currency, state.locale);
        compareEl.style.display = 'inline';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (saveEl && saveContainer) {
      // Use the variant's own compare_at_price for savings calculation
      const variant = state.selectedVariant;
      const baseCompareAt = variant ? (variant.compare_at_price || variant.price || 0) : 0;
      if (baseCompareAt > state.discountedPrice) {
        const actualSavings = baseCompareAt - state.discountedPrice;
        saveEl.textContent = formatMoney(actualSavings, state.currency, state.locale);
        saveContainer.style.display = 'block';
      } else {
        saveContainer.style.display = 'none';
      }
    }
	
  });
}

// Helper for formatting money
function formatMoney(cents, currency = 'GBP', locale = 'en-GB') {
  if (typeof cents !== 'number') return '';
  
  // Use Shopify's built-in money formatting if available
  if (window.Shopify && window.Shopify.formatMoney && window.moneyFormat) {
    return Shopify.formatMoney(cents, window.moneyFormat);
  }
  
  // Fallback to Intl.NumberFormat with provided currency and locale
  return (cents / 100).toLocaleString(locale, { style: 'currency', currency });
} 